/*
 * @Descripttion:
 * @version:
 * @Author: geory
 * @Date: 2023-09-01 15:50:46
 * @LastEditors: geory
 * @LastEditTime: 2026-10-16 14:03:00
 */
import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter);
import config from "./config/config";
import store from "./store/index";

const Login = () => import("./components/Login");
const WLogin = () => import("./components/WLogin");
const Home = () => import("./components/Home");
const WHome = () => import("./components/WHome");
const ImageList = () => import("./components/ImageList");
const HuashuEdit = () => import("./components/HuashuEdit");
const HuashuImport = () => import("./components/HuashuImport");
const Download = () => import("./components/Download");
const Setting = () => import("./components/Setting");
const TestPC = () => import("./components/TestPC");
const AuthGuide = () => import("./components/AuthGuide");
const HuashuReview = () => import("./components/HuashuReview");
const AutoSend = () => import("./components/AutoSend");
const MemoEditWindow = () => import("./components/MemoEditWindow");

const wminputWeb = [
  {
    path: "/autoSend",
    name: "autoSend",
    component: AutoSend,
    meta: {
      keepAlive: false,
    },
  },
  {
    path: "/memoEdit",
    name: "memoEdit",
    component: MemoEditWindow,
    meta: {
      keepAlive: false,
      hideTopBar: true,
    },
  },
  {
    path: "/setting",
    name: "setting",
    component: Setting,
    meta: {
      keepAlive: false,
    },
  },
  {
    path: "/login",
    name: "login",
    component: Login,
    meta: {
      keepAlive: false,
    },
  },
  {
    path: "/home",
    name: "home",
    component: Home,
    meta: {
      keepAlive: true,
    },
  },
  {
    path: "/imageList",
    name: "imageList",
    component: ImageList,
    meta: {
      keepAlive: false,
    },
  },
  {
    path: "/huashuEdit",
    name: "huashuEdit",
    component: HuashuEdit,
    meta: {
      keepAlive: false,
    },
  },
  {
    path: "/huashuImport",
    name: "huashuImport",
    component: HuashuImport,
    meta: {
      keepAlive: false,
    },
  },
  {
    path: "/authGuide",
    name: "authGuide",
    component: AuthGuide,
    meta: {
      keepAlive: false,
      hideTopBar: true,
    },
  },
  {
    path: "/",
    name: "download",
    component: Download,
  },
];

const wminputManager = [
  {
    path: "/huashuReview",
    name: "huashuReview",
    component: HuashuReview,
    meta: {
      keepAlive: false,
      hideTopBar: true,
    },
  },
  {
    path: "/wlogin",
    name: "wlogin",
    component: WLogin,
    meta: {
      keepAlive: false,
    },
  },
  {
    path: "/whome",
    name: "whome",
    component: WHome,
    meta: {
      keepAlive: true,
    },
  },
];

const routerParams =
  config.app === "wminputWeb"
    ? {
        routes: wminputWeb,
        mode: "history",
        base: "/pc",
      }
    : {
        routes: wminputManager,
      };

const router = new VueRouter(routerParams);

// 非主窗口路由（独立小窗口）—— 禁止在这些窗口显示引导弹层
const NON_GUIDE_ROUTES = [
  "/authGuide",
  "/setting",
  "/autoSend",
  "/huashuEdit",
  "/huashuImport",
  "/imageList",
  "/huashuReview",
  "/memoEdit",
];

router.beforeEach((to, from, next) => {
  if (NON_GUIDE_ROUTES.includes(to.path)) {
    if (store.state.guideVisible) {
      store.commit("hideGuide");
    }
  }
  // 兜底守卫：没有登录态时不允许停留在主页面。
  // 现场缺陷：退出登录存在"router.push 还没落地就 window.location.reload()"的竞态，
  // reload 可能重新加载 #/home —— 此时 token 已清空，页面又没有任何守卫，用户就
  // 永久卡在空白首页、找不到登录入口（"退出登录后登录不上去"）。
  // 这里统一把没有 token 的首页访问送回登录页，任何路径都不会再卡死。
  if (
    (to.path === "/home" || to.path === "/whome") &&
    !localStorage.getItem("edujia:group:web:token")
  ) {
    next({ path: to.path === "/whome" ? "/wlogin" : "/login", replace: true });
    return;
  }
  next();
});

//router.beforeEach()
export default router;
